// แปลงรูปที่เลือกก่อนอัพขึ้น storage — กันเคส "ใส่รูปไม่ได้"
//  - ไฟล์ใหญ่จากมือถือ (เกิน limit ของ bucket) → ย่อขนาด
//  - ฟอร์แมตแปลก (webp / heic / png โปร่งใส) → แปลงเป็น JPEG ที่แสดงผลได้เสมอ
// ถ้า decode ไม่ได้ (เช่น HEIC บนเบราว์เซอร์ที่ไม่รองรับ) → คืนไฟล์เดิม (best effort)
export async function toUploadableImage(file, { maxDim = 1600, quality = 0.85 } = {}) {
  if (!file || !file.type?.startsWith('image/')) return file;
  let bitmap;
  try { bitmap = await createImageBitmap(file); }
  catch { return file; }
  try {
    let { width, height } = bitmap;
    const scale = Math.min(1, maxDim / Math.max(width, height));
    width = Math.max(1, Math.round(width * scale));
    height = Math.max(1, Math.round(height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width; canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, width, height);   // พื้นขาวแทนโปร่งใส (ไม่งั้นเป็นสีดำ)
    ctx.drawImage(bitmap, 0, 0, width, height);
    const blob = await new Promise(res => canvas.toBlob(res, 'image/jpeg', quality));
    if (!blob) return file;
    const base = (file.name || 'photo').replace(/\.[^.]+$/, '');
    return new File([blob], `${base}.jpg`, { type: 'image/jpeg', lastModified: Date.now() });
  } finally { bitmap.close?.(); }
}
